import React, { useEffect, useState } from "react";
import { withRouter } from 'react-router-dom';
import Icon from '@material-ui/core/Icon';
import { Button } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress';
import { apiCall, logOut } from '../../../common/apiconfig';
import FormHoc from '../../hoc/formHoc';
import { InputField, AutoOptions } from '../../formElements';
import { Dropdowns } from '../../../common/constants';
import { connect } from 'react-redux';
import BackIcon from '../../../../img/back1.svg'
import Img from '../../../../img/RBM.svg'
import AuditTrailFunc from '../../../common/AuditTrailFunc'

const UpdateRBM = (propsobj) => {
  let [apiError, setApiError] = useState(false);
  let [progress, setProgress] = useState(false);
  let [oldData, setOldData] = useState({});
  useEffect(() => {
    setOldData(propsobj.formValues)
  }, [oldData])
  useEffect(() => {
    // propsobj.clearForm();
    // propsobj.UpdateFormField({value:propsobj.formValues.accountName,name:"accountName"})
  }, []);

  const hocObj = FormHoc(propsobj);

  const textProps = {
    ...hocObj,
    propsobj
  }

  const autoPropstoseverity = {
    default: null,
    'options': Dropdowns.Protocol_Setup_RBM_Severity,
    freeSolo: false,
    propsobj,
    keys: ['value']
  }

  const autoPropstostatus = {
    ...autoPropstoseverity,
    'options': Dropdowns.Account_Status,
    default: null,
  }


  const formSubmit = async (event) => {
    event.preventDefault();
    let setGo = await hocObj.handleSubmit('updateRBM', event);

    if (setGo) {
      setProgress(true);
      let form = propsobj.formValues;
      console.log(form)
      let requestBody = `
      mutation 
      {
        updateStudyEvent(effectiveDate: "2020-05-14", studyId: "${form.studyId}" ,eventId:"${form.eventId}",eventType: "A",type: "${form.rbm_type}", description: ${JSON.stringify(form.rbm_description)},status: "${form.rbm_status}", severity:"${form.rbm_severity}") {
          code
          type
          message
          attributes
        }  
      }
          `;

      requestBody = JSON.stringify({ query: requestBody });
      let res = await apiCall('updateStudyEvent', requestBody, form);
      setProgress(false);

      if (res && res.data.updateStudyEvent.code === '200') {
        console.log('added! ');
        AuditTrailFunc("Study", propsobj.formValues.studyId, "RBM Update", "RBM ID: " + propsobj.formValues.eventId, oldData, propsobj.formValues)
        // propsobj.UpdateFormField({value:propsobj.formValues.accountName,name:"accountName"})
        // propsobj.clearForm();
        propsobj.history.goBack();
        //logOut();
      } else {
        console.log('Error on response add account file!')
        //props.history.push('/account/updateContact'); // temp enabling to check update sponsor
      }
    }
  }

  const handleCancel = (event) => {
    event.preventDefault();
    // propsobj.UpdateFormField({value:propsobj.formValues.accountName,name:"accountName"})
    propsobj.history.push('/account/studyDetails/rbm')
  }

  const goBack = (event) => {
    event.preventDefault();
    propsobj.history.push('/account/studyDetails/rbm')
  }

  return (
    <>
      {progress && <div className="fullScreen">
        <CircularProgress
          disableShrink
          className="progressCircle"
          value={90}
          size={100}
          thickness={1.5}
        />
      </div>}
      {/* <div onClick={goBack} className="subNavText"><img src={BackIcon} alt="goback" />  BACK TO RBM LIST</div><br/> */}
      <div className="d-flex mt-4 justify-content-end">
        <div className="mr-auto secondary-header">Edit Risk</div>
      </div>

      <div className="">
        <form noValidate autoComplete="off" id="updateRBM" className="row" onSubmit={formSubmit}>
          <div className="col-md-6">
            <div className="panel-primary-wrap">
              <div className="card">
                <div className="card-body">
                  {/* <div className="card-page-header">NAME INFORMATION</div> */}
                  <div className="inputBox">
                    <InputField {...textProps} name="rbm_type" label="Risk Name" keyName='value' must={'true'} />
                    <InputField {...textProps} multiline={true} row={1} rowsMax={2} name="rbm_description" label="Description" must={'true'} type="text" />
                    <AutoOptions {...autoPropstoseverity} name="rbm_severity" label="Severity" keyName='value' must={'true'} />
                    <AutoOptions {...autoPropstostatus} name="rbm_status" label="Status" keyName='value' must={'true'} />
                  </div>
                </div>
              </div>
            </div>
            <div className="buttonContainer">
              <button type="submit" className="btn btn-primary-blue btn-rounded btn-small mr-1">Save</button>
              <button className="btn btn-primary-grey btn-rounded btn-small" onClick={goBack}>CANCEL</button>
            </div>
          </div>
          <div className="col-md-6" style={{ textAlign: 'center' }}>
            <img src={Img} alt="Image" />
          </div>
        </form>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateFormField: (obj) => {
      return dispatch(
        {
          type: 'UpdateFormField',
          value: obj.value,
          name: obj.name
        }
      )
    },
    clearForm: () => {
      return dispatch(
        {
          type: 'ClearForm',
        }
      )
    },
    updateErrorObj: (obj) => {
      return dispatch(
        {
          type: 'updateErrorObj',
          flag: obj.flag,
          name: obj.name,
          text: obj.text
        }
      )
    },
    updateEntireErrorObj: (errobj, errtextobj) => {
      return dispatch(
        {
          type: 'updateEntireErrorObj',
          errobj: errobj,
          errtextobj: errtextobj,
        }
      )
    },
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UpdateRBM));



